import React from "react";

import {
  Button,
  ButtonVariant,
} from "@patternfly/react-core";

import { useBreakpoint } from "shared/hooks/useBreakpoint";
import { LINKS } from "shared/config/links";
import { Icons } from "shared/components/Icons";

const SchoolMailButton = ({compact = false}) => {
  const { isSmallMobile } = useBreakpoint();

  if (isSmallMobile) {
    return null;
  }

  return (
    <Button
      variant={ButtonVariant.secondary}
      icon={compact ? Icons.ContactIcon : undefined}
      // iconPosition="end"
      component="a"
      href={LINKS.POCZTA}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={compact ? "Poczta" : undefined}
      title={compact ? "Poczta" : undefined}
    >
      {!compact && "Poczta"}
    </Button>
  );
};

export default SchoolMailButton;